<template>
  <div class="my-wallet-content zs">
    <div class="account">
      <img src="../imgs/zs-wallet.png" alt="">
      <div class="account-btns">
        <el-button v-permission="['zs:unit:withdraw']" size="small" type="primary" @click="handleReflect">
          提现
        </el-button>
        <el-button v-permission="['zs:unit:withdraw']" size="small" type="primary" @click="showChargeDialog = true">
          充值
        </el-button>
        <el-button size="small" type="primary" @click="toManagement">
          管理
        </el-button>
      </div>
    </div>

    <div class="account-money">
      <div class="account-money-item">
        <div class="title">
          可用余额(元)
        </div>
        <div class="money">
          {{ isNull(data?.availableBalance) ? '--' : data?.availableBalance }}
        </div>
      </div>
    </div>

    <div class="account-info">
      <div class="left">
        <div class="account-info-title">
          <span class="label">服务商：</span>
          <span class="value">{{ isNull(data?.serverName) ? '--' : data?.serverName }}</span>
        </div>
        <div class="account-info-title">
          <span class="label">账&nbsp;&nbsp;&nbsp;户：</span>
          <span class="value">{{ isNull(data?.accountNo) ? '--' : data?.accountNo }}</span>
        </div>
      </div>
      <el-popover popper-class="homepage-wallet-popover" placement="bottom-end" :width="460">
        <template #reference>
          <span class="account-info-btn">详细信息
            <svg-icon class="!w-3" icon="uiw:down" />
          </span>
        </template>

        <div class="flex flex-col py-2 px-2">
          <strong class="pb-4">基本信息</strong>
          <div class="finance-zl-info-box">
            <div>
              <label>企业名称：</label>
              <span>{{ data.bizName || '--' }}</span>
            </div>
            <div>
              <label>共管账户：</label>
              <span>{{ data.accountNo || '--' }}</span>
            </div>
            <div>
              <label>服务商名称：</label>
              <span>{{ data.serverName || '--' }}</span>
            </div>
          </div>
        </div>
      </el-popover>
    </div>

    <!-- 提现 -->
    <zhao-hang-withdraw
      :visible="showWithdrawDialog"
      :data="data"
      :term="term"
      :loading="withdrawLoading"
      :pay-phone="payInfo?.payPhone"
      @close="showWithdrawDialog = false"
      @confirm="doWithdraw"
    />

    <!-- 充值 -->
    <zhao-hang-charge
      :visible="showChargeDialog"
      :data="data"
      @close="showChargeDialog = false"
    />
  </div>
</template>

<script setup lang='ts'>
import { onConfirm, SvgIcon } from '@vue3/components';
import { IFinanceWallet } from '@core/main/types/finance';
import { inject, nextTick, Ref, ref } from 'vue';
import { doZsWithdraw, ZhaoHangWithdraw } from '@core/main';
import ZhaoHangCharge from '../../finance/wallets/zs/ZhaoHangCharge.vue';
import { isNull } from '@core/tools';
import { EHasPayPassword, ISecuritySettingDetail } from '@core/main/types';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';

const emit = defineEmits(['reload']);

const router = useRouter();

const data = inject<Ref<IFinanceWallet>>('data');
const payInfo = inject<Ref<ISecuritySettingDetail>>('payInfo');
const term = inject<'server' | 'company' | 'agent'>('term');

const showWithdrawDialog = ref(false);
const withdrawLoading = ref(false);
const showChargeDialog = ref(false);

async function doWithdraw(params) {
  withdrawLoading.value = true;

  try {
    await doZsWithdraw(params);

    ElMessage.success('提现成功');
    showWithdrawDialog.value = false;

    nextTick(() => {
      emit('reload');
    });
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  withdrawLoading.value = false;
}

function handleReflect() {
  if (payInfo.value?.hasPayPassword === EHasPayPassword.NOT_SET) {
    onConfirm({
      message: '您未设置支付密码，请前往设置！',
      okText: '去设置',
      onOk: async () => {
        router.push({ name: 'SecuritySettings' });
      },
    });
    return;
  }

  showWithdrawDialog.value = true;
}

function toManagement() {
  router.push({
    name: 'WalletManagement',
    query: { unitId: data.value?.accountId },
  });
}

</script>

<style lang="scss" scoped src="../style/my-wallet.scss" />